import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { SharedService } from 'src/app/services/shared.service';
import { ReservationService } from 'src/app/services/reservation.service';
import * as moment from "moment-timezone";
const emails = require('../../services/emails.json');

@Component({
  selector: 'app-vtuber-reserve-cancel',
  templateUrl: './cancel.component.html',
  styleUrls: ['./cancel.component.scss']
})
export class ReserveCancelComponent implements OnInit, OnDestroy {
  reserveInfo: any;
  cancelReason: string = '';

  constructor(
    public auth: AuthService,
    private shared: SharedService,
    private rs: ReservationService
  ) {}

  ngOnInit() {
    if (this.shared.getCookie(SharedService.CURRENT_CANCEL_RESERVE) === undefined) {
      this.shared.redirect('/reserve/list');
      return;
    }

    this.reserveInfo = this.shared.getCookie(SharedService.CURRENT_CANCEL_RESERVE);
  }

  ngOnDestroy() {
    this.shared.removeCookie(SharedService.CURRENT_CANCEL_RESERVE)
  }

  updateUserInfo(user) {
    if (user.active_reservations) {
      user.active_reservations = user.active_reservations.map(item => {
        if (item.vtuber_uid === this.reserveInfo.vtuber_uid) item.count--;
        return item;
      })
    }

    if (this.canRefundTime()) {
      user.plans = user.plans.map(item => {
        if (item.vtuber_id === this.reserveInfo.vtuber_uid) item.used_period = parseInt(item.used_period) - parseInt(this.reserveInfo.duration) * 1
        return item
      })
    }

    this.auth.updateUserData(user);
    this.auth.fetchUser();
  }

  updateVtuberInfo(vtuber) {
    vtuber.events = vtuber.events.map(item => {
      if (item.uid === this.reserveInfo.event_uid) {
          item.reservations = (item.reservations !== undefined && item.reservations.length > 0) ? item.reservations.filter(a => a.reservation_id !== this.reserveInfo.id) : []
          item.hasArrangement = item.reservations.length > 0
      }
      return item
    })

    this.auth.updateUserData(vtuber);
  }

  cancel() {
    let params = Object.assign({}, this.reserveInfo)
    params.uid = params.id;
    delete params.id;
    delete params.target;

    params.status = ReservationService.CANCELLED
    if (this.auth.user.role === AuthService.USER_ROLE) {
      params.user_cancel = this.cancelReason
    } else {
      params.vtuber_cancel = this.cancelReason
    }

    this.auth.toggleSpinner(true)
    this.rs.updateReservationData(params)
    .then(() => {
      let esender = undefined
      let evtuber = undefined
      if (this.auth.user.role === AuthService.USER_ROLE) {
        // Update User
        let user = Object.assign({}, this.auth.user)
        this.updateUserInfo(user)

        // Update Vtuber
        let vtuber = this.reserveInfo.target
        this.updateVtuberInfo(vtuber)

        esender = this.auth.user
        evtuber = vtuber
      } else {
        // Update User
        let user = this.reserveInfo.target
        this.updateUserInfo(user)

        // Update Vtuber
        let vtuber = Object.assign({}, this.auth.user)
        this.updateVtuberInfo(vtuber)

        // Send Notification
        this.rs.sendNotification(this.auth.user.uid, vtuber.uid, {
          content: this.shared.getReserveTime(this.reserveInfo) + "の通話予約をキャンセルしました。\n" + this.cancelReason
        })

        esender = user
        evtuber = this.auth.user
      }


      // Send Email
      if (this.auth.user.role === AuthService.USER_ROLE) {
        this.auth.sendEmail({
          to: evtuber.email,
          subject: emails.reserve_cancel_vtuber_subject,
          text: this.auth.getEmailTemplate(emails.reserve_cancel_vtuber.join("")).replace(/\[VTuber名\]/g, evtuber.displayName)
                              .replace(/\[支援者名\]/g, esender.displayName)
                              .replace(/\[通話予約の日時\]/g, moment(params.reserveAt).format("Y年MM月DD日 ") + params.start + " ~ " + params.end)
                              .replace(/\[キャンセル時理由\]/g, this.cancelReason)
        })
      } else {
        this.auth.sendEmail({
          to: esender.email,
          subject: emails.reserve_cancel_subject,
          text: this.auth.getEmailTemplate(emails.reserve_cancel.join("")).replace(/\[VTuber名\]/g, evtuber.displayName)
                              .replace(/\[ユーザー名\]/g, esender.displayName)
                              .replace(/\[通話予約の日時\]/g, moment(params.reserveAt).format("Y年MM月DD日 ") + params.start + " ~ " + params.end)
                              .replace(/\[キャンセル時\]/g, this.cancelReason)
        })
      }

      this.auth.toggleSpinner(false)
      this.shared.redirect('/reserve/list');
    })
  }

  isUser() {
    return this.auth.user.role === AuthService.USER_ROLE
  }

  canRefundTime() {
    if (this.auth.user.role === AuthService.VTUBER_ROLE) return true;

    let start = moment(this.reserveInfo.reserveAt + " " + this.reserveInfo.start).add(-2, "days");
    return start > moment();
  }
}
